var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { parseCsvAsJson } from "../parsers/parseCsvAsJson";
export var DatasetFormat;
(function (DatasetFormat) {
    DatasetFormat["Json"] = "Json";
    DatasetFormat["JsonInCsv"] = "JsonInCsv";
    DatasetFormat["RawCsv"] = "RawCsv";
})(DatasetFormat || (DatasetFormat = {}));
export const datasetFormat = (ext, rawCsv) => {
    switch (ext) {
        case ".json":
            return DatasetFormat.Json;
        case ".csv":
            return rawCsv ? DatasetFormat.RawCsv : DatasetFormat.JsonInCsv;
        default:
            return null;
    }
};
export const parseDatasetUrl = (url, rawCsv) => {
    const pathname = new URL(url).pathname;
    const ext = pathname.substring(pathname.lastIndexOf("."));
    const format = datasetFormat(ext, rawCsv);
    return { pathname, ext, format };
};
export class DatasetRequestError extends Error {
    constructor() {
        super(...arguments);
        this.name = "DatasetRequestError";
    }
}
export function fetchDataset(url, format, inPlaceData, signal) {
    return __awaiter(this, void 0, void 0, function* () {
        let responseText = null;
        if (inPlaceData) {
            responseText = inPlaceData;
        }
        else {
            const response = yield fetch(url, { signal }).catch((err) => {
                console.error(err);
                return null;
            });
            if (!response) {
                throw new DatasetRequestError("Could not fetch dataset");
            }
            if (!response.ok) {
                throw new DatasetRequestError(`${response.status}: ${response.statusText}`);
            }
            responseText = yield response.text();
        }
        switch (format) {
            case DatasetFormat.Json:
            case DatasetFormat.JsonInCsv:
                const text = responseText;
                try {
                    return JSON.parse(text);
                }
                catch (_a) {
                    return text;
                }
            case DatasetFormat.RawCsv: {
                const csvText = responseText;
                const jsonStr = yield parseCsvAsJson(csvText);
                return JSON.parse(jsonStr);
            }
        }
    });
}
